import type { ReactElement } from "react";

import { Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import * as siRoutes from "app/pages/sales-intelligence/constants/routes";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { isContactNameHidden } from "app/pages/sales-intelligence/sub-modules/contacts-search/utils/isContactNameHidden";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { StyledCraftEmailIconButton } from "./styles";

interface IProps {
    domain: string;
    recipient: string;
    onClick?: VoidFunction;
}

const CraftEmailIconButton = ({ domain, recipient, onClick }: IProps): ReactElement => {
    const isDisabled = salesSettingsHelper.isAiCraftEmailAgentHidden || salesSettingsHelper.isAiCraftEmailAgentLocked;

    const craftAnEmailLink = proNavigator.href(siRoutes.AI_AGENT_EMAIL, {
        domain,
        recipient: !recipient || isContactNameHidden(recipient) ? undefined : recipient,
        autogenerate: true,
    });

    const button = (
        <StyledCraftEmailIconButton
            type="flat"
            isDisabled={isDisabled}
            iconName="craft-email-colored"
            iconSize="xs"
            dataAutomation="actions-cell.button.craft-email"
            onClick={onClick}
        />
    );

    const content = isDisabled ? (
        button
    ) : (
        <a
            href={craftAnEmailLink}
            target="_blank"
        >
            {button}
        </a>
    );

    return (
        <Tooltip content={translate(`si.contacts_search.table.column.actions.craft-email.tooltip`)}>{content}</Tooltip>
    );
};

export default CraftEmailIconButton;
